import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { SinglePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/PaymentMethodDetail/SinglePaymentMethodDetailEntity';

// PENDING_ACTION_COMPLETE: 'Completar el proceso de solicitud',
// PENDING_ACTION_EVALUATE: 'Hacer click en Evaluar para enviar la solicitud a las entidades financieras.', //FIXME: NON-SENSE
// PENDING_ACTION_PAY: 'Hacer click en Pagar para completar el pago.',
// PENDING_ACTION_UPLOAD_DOCUMENTS: 'Subir los documentos requeridos',
// PENDING_ACTION_REVIEW_DOCUMENTS: 'Revisar los documentos subidos',
// PENDING_ACTION_SIGN_CONTRACT: 'Firmar el contrato digitalmente',
// PENDING_ACTION_PAY_FIRST_INSTALMENT: 'Pagar primera cuota con tarjeta',

export class ActionsMap {
  static fromPaymentMethodDetail(paymentMethodDetail: SinglePaymentMethodDetailEntity): Action[] | null {
    if (paymentMethodDetail.isExpired()) {
      return null;
    }

    return [Action.PAY];
  }
}
